module.exports = " <div> <div class=tabs v-bind:class=\"{normal:type=='normal',pills:type=='pills','col-2':tabnum,'col-3':!tabnum}\"> <div v-for=\"(tabs,index) in tablist\" class=tab v-bind:class=\"{active:tabindex==index}\" v-on:click=tab(index)>{{tabs.title}}</div> </div> <div class=tabs-content> <slot></slot> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tabs.vue
// module id = 132
// module chunks = 1